module.exports = __webpack_public_path__ + "img/tramites-online.590533b2.jpg";